import axios from "./axios-auth";

const getAllSuppliers = (data) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getallsuppliers",
      params: {},
      data: data,
      method: "POST",
    })
      .then((resp) => {
        console.log(resp, "resp from getAllSuppliers api");
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error from api folder while calling axios");
      });
  });

const getSupplierById = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getsupplierbyid",
      params: params,
      method: "GET",
    })
      .then((resp) => {
        console.log(resp, "sidebarModules api");
        resolve(resp.data);
      })
      .catch(() => {
        console.log("error from api folder while calling axios");
      });
  });

const insertSupplier = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/addSupplier",
      data: params,
      method: "POST",
    })
      .then((resp) => {
        console.log(resp, " from insert supplier api");
        if (resp.status !== 200){
          throw new Error(resp.data.message);
        }
        resolve(resp.data);
      })
      .catch((err) => {
        alert(err);
        console.log(err, "from insert supplier api");
      });
  });

const editSupplier = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/updateSupplierById",
      data: params,
      method: "PUT",
    })
      .then((resp) => {
        console.log(resp, " from edit supplier api");
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err, "from edit supplier api");
      });
  });

const deleteSupplier = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/deleteSupplierById",
      params: params,
      method: "DELETE",
    })
      .then((resp) => {
        console.log(resp, " from delete supplier api");
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err, "from delete supplier api");
      });
  });

export {
  getAllSuppliers,
  getSupplierById,
  insertSupplier,
  editSupplier,
  deleteSupplier,
};
